import React from "react";
import {
  IconButton,
  InputAdornment,
  OutlinedInput,
  useTheme,
} from "@mui/material";
import { IconSearch } from "@tabler/icons";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch } from "react-redux";
import { saveSearch } from "store/user.store";

const SearchOutlinedComponent = (props) => {
  const { label = "Ricerca", valueSearch, handleSearch } = props;
  const theme = useTheme();
  const dispatch = useDispatch();

  return (
    <OutlinedInput
      placeholder={label}
      onChange={handleSearch}
      startAdornment={
        <InputAdornment position="start">
          <IconSearch stroke={2} size="16px" />
        </InputAdornment>
      }
      endAdornment={
        valueSearch !== "" && valueSearch !== undefined && valueSearch !== null && (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={() => {
                handleSearch({ target: { value: "" } })
                dispatch(saveSearch(null))
              }
              }
            >
              <ClearIcon fontSize="24px" />
            </IconButton>
          </InputAdornment>
        )
      }
      value={valueSearch}
      margin="dense"
      size="small"
      sx={{
        width: "100%",
        height: 37,
        "& input::placeholder": {
          color: theme.palette.text.secondary,
          opacity: 1,
          fontWeight: 400,
        },
      }}
    />
  );
};

export default SearchOutlinedComponent;
